<template>
  <div class="candidate-experiences-list">
    <div class="candidate-experiences-list-title">{{ $t("ETAB.PAGES.EXTRA.@OTHER_EXPERIENCES_TITLE") }}</div>
    <div v-for="(etablissement, index) in displayedExperiences" :key="index" class="candidate-experiences-list-item flex row q-mt-md">
      <div class="candidate-experiences-list-item-container">
        <div v-if="etablissement.etab_experiences.length > 1" class="candidate-experiences-list-container">
          <div class="candidate-experiences-list-item-timeline">
            <div class="candidate-experiences-list-item-dot" />
            <div class="candidate-experiences-list-item-line" />
          </div>
          <MultipleExperiencesComponent :experience="etablissement" :is-other-xp="true" />
        </div>
        <div v-else class="candidate-experiences-list-container">
          <div class="candidate-experiences-list-item-timeline">
            <div class="candidate-experiences-list-item-dot" />
            <div class="candidate-experiences-list-item-line" />
          </div>
          <SingleExperienceComponent :shift="etablissement.etab_experiences[0]" :is-other-xp="true" />
        </div>
      </div>
    </div>
    <div v-if="shouldShowMoreButton" class="text-center">
      <QBtn
        class="text-underline"
        flat
        dense
        no-caps
        :label="showMore ? $t('ETAB.PAGES.EXTRA.@SHOW_LESS_EXPERIENCES') : $t('ETAB.PAGES.EXTRA.@SHOW_MORE_EXPERIENCES')"
        @click="toggleShowMore"
      />
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, defineProps } from "vue";
  import SingleExperienceComponent from "./SingleExperience.component.vue";
  import MultipleExperiencesComponent from "./MultipleExperiences.component.vue";

  const props = defineProps({
    experiences: {
      type: Array,
      default: () => [],
    },
  });

  // Flatten all experiences from all qualifications into a single array
  const allExperiences = computed(() => {
    return props.experiences.flatMap((qualification) =>
      qualification.experiences.map((etablissement) => ({
        ...etablissement,
        qualification: qualification.qualification,
        qualification_is_verified: qualification.is_verified,
      })),
    );
  });

  const showMore = ref(false);

  const toggleShowMore = () => {
    showMore.value = !showMore.value;
  };

  // Display only first 2 experiences, or all if showMore is true
  const displayedExperiences = computed(() => {
    if (showMore.value) {
      return allExperiences.value;
    }
    return allExperiences.value.slice(0, 2);
  });

  // Show button if there are more than 2 experiences total
  const shouldShowMoreButton = computed(() => {
    return allExperiences.value.length > 2;
  });
</script>

<style lang="scss">
  .candidate-experiences-list {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    &-title {
      font-size: 20px;
      font-weight: 600;
      padding-top: 10px;
      padding-left: 16px;
    }
    .extra-certification-badge {
      .picture {
        width: 20px;
        height: 20px;
      }
    }
    &-item {
      display: flex;
      position: relative;
      &-container {
        width: 100%;
      }
      &-timeline {
        position: relative;
        margin-right: 10px;
        margin-left: 10px;
        width: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      &-dot {
        width: 16px;
        height: 16px;
        background-color: #ccc;
        border-radius: 50%;
        z-index: 1;
      }

      &-line {
        position: absolute;
        top: 20px;
        width: 3px;
        height: calc(100% - 40px);
        background-color: #ccc;

        &.experience-line-adjusted {
          height: calc(100% - 20px);
        }
      }
    }
    &-container {
      width: 100%;
      padding-left: 10px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      padding-right: 5px;
    }
  }
</style>
